<template>
  <div class="practice-hands practicepage">
    <div class="practicepage_inner">
      <h1 class="f-align-center pb-2 text-large">
        {{ link.title }}
      </h1>
      <PracticeHandsTotals
        :filterConfig="filterConfig"
        :hasFilters="true"
      />

      <SnackbarLinkGuide
        localKey="trainer_stats"
        :link="links_url_links.trainer_stats.url"
        :text="$t('messages.get_most_of_stats')"
      />
    </div>
  </div>
</template>

<script>
import Snackbar from '@/components/Messages/Snackbar'
import SnackbarLinkGuide from '@/components/Messages/SnackbarLinkGuide'
import links_mix from '@/mixins/links_mix'
import PracticeHandsTotals from '@/components/PracticeHandsTotals/PracticeHandsTotals'
import { getLocalFiltersConfigs } from '@/components/DataTables/Filters/new/filter_helpers'

export default {
  name: 'PracticeStats',
  components: {
    PracticeHandsTotals,
    // Snackbar,
    SnackbarLinkGuide,
  },
  mixins: [links_mix],
  data() {
    this.filterConfig = getLocalFiltersConfigs().practiceStats
    return {}
  },
  computed: {
    link() {
      return this.links_getItem({ options: this.links_practice_all, pathName: 'PracticeStats' })
    },
  },
}
</script>
